(function () {
  'use strict';

  // ---------- Mobile nav ----------
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.querySelector('[data-mobile-nav]');
      if (!panel) return;
      var open = panel.hasAttribute('data-open');
      if (open) { panel.removeAttribute('data-open'); panel.hidden = true; }
      else      { panel.setAttribute('data-open', ''); panel.hidden = false; }
    });
  });

  // ---------- Product: size (variant) toggle ----------
  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var group      = card.querySelector('[data-size-toggle]');
    var priceOut   = card.querySelector('[data-price-out]');
    var variantIn  = card.querySelector('[data-variant-input]');
    var mediaEl    = card.querySelector('[data-product-media]');
    var addBtn     = card.querySelector('[data-add-btn]');
    if (!group) return;

    group.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        group.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');

        if (priceOut && b.dataset.price)     priceOut.textContent = b.dataset.price;
        if (variantIn && b.dataset.variantId) variantIn.value     = b.dataset.variantId;
        if (mediaEl && b.dataset.image)       mediaEl.style.backgroundImage = "url('" + b.dataset.image + "')";

        if (addBtn) {
          var available = b.dataset.available === 'true';
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'Add to Cart \u2192' : 'Sold out';
        }
      });
    });
  });

  // ---------- Quantity controls ----------
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('[data-qty-input]');
    if (!input) return;
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var delta = parseInt(b.dataset.qty, 10);
        var next  = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
      });
    });
  });

  // ---------- Thumbnail swap ----------
  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var media  = card.querySelector('[data-product-media]');
    var thumbs = card.querySelectorAll('[data-thumb]');
    if (!media || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (t.dataset.full) media.style.backgroundImage = "url('" + t.dataset.full + "')";
      });
    });
  });

  // ---------- Add to cart (AJAX, falls back to normal POST on error) ----------
  document.querySelectorAll('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // let browser submit normally on ancient browsers
      e.preventDefault();
      var btn  = form.querySelector('[data-add-btn]');
      var orig = btn ? btn.innerHTML : '';
      if (btn) btn.innerHTML = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        if (btn) {
          btn.innerHTML = 'Added \u2713';
          btn.style.background = 'var(--mustard)';
          btn.style.borderColor = 'var(--mustard)';
          btn.style.color = 'var(--cream)';
          setTimeout(function () {
            btn.innerHTML = orig;
            btn.style.background = '';
            btn.style.borderColor = '';
            btn.style.color = '';
          }, 1500);
        }
        // Update cart count
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var el = document.querySelector('.nav-cart');
          if (el) el.textContent = 'Cart (' + cart.item_count + ')';
        });
      }).catch(function () {
        // Hard fallback: submit normally
        form.submit();
      });
    });
  });
})();
